import React from "react";
import { useNavigate } from "react-router-dom";

export default function SeflCreatedSuccess({ setSelfAssessmentCreated, setNewSelfAssment }) {
  const navigate = useNavigate();
  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess d-flex flex-column justify-content-center">
        <div className="d-flex justify-content-center align-items-center">
          <img src="/HwImg/sucessIcon.png" alt="" />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg1">
          You Have successfully Created the Self Assessement
        </div>
        <div className="d-flex justify-content-center align-items-center mt-3">
          <button
            className="okayBtnsucess"
            onClick={() => {
              setSelfAssessmentCreated(false);
              setNewSelfAssment(Date.now());
              navigate('/SelfAssessment', { replace: true })
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
